import { createFileRoute } from '@tanstack/react-router';

import { metadataQuery } from '@@components/Page/loadContentDetail';
import { placementHistorySearchParams } from '@@containers/placementHistory/placementHistorySearchParams';
import { handleLoaderError } from '@@router/handleLoaderError';

import { PlacementHistoryRoute } from './-components/PlacementHistoryRoute';

export const Route = createFileRoute('/_authenticated/placement/history/$metadataId')({
    validateSearch: placementHistorySearchParams,
    loader: ({ context, params }) =>
        context.queryClient
            .query({ ...metadataQuery(Number(params.metadataId)), staleTime: 'static' })
            .catch(handleLoaderError),
    component: PlacementHistoryRoute,
});
